let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("7fqGF")).then(() => parcelRequire('d3KbN'));